import { useEffect } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import "@/App.css";
import { MessageCircle } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { setLenis } from "@/lib/scroll";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Story } from "@/components/site/Story";
import { Products } from "@/components/site/Products";
import { Flavours } from "@/components/site/Flavours";
import { Partners } from "@/components/site/Partners";
import { Leadership } from "@/components/site/Leadership";
import { Distributor } from "@/components/site/Distributor";
import { Footer } from "@/components/site/Footer";
import { CONTACT } from "@/components/site/data";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.085, smoothWheel: true });
    setLenis(lenis);
    let id = 0;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div className="App min-h-screen bg-ns-ivory font-sans text-ns-ink">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Story />
        <Products />
        <Flavours />
        <Partners />
        <Leadership />
        <Distributor />
      </main>
      <Footer />
      <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp" data-testid="floating-whatsapp-button" className="fixed bottom-5 right-5 z-40 grid h-14 w-14 place-items-center rounded-full bg-ns-emerald text-ns-gold shadow-[0_20px_40px_-12px_rgba(4,27,19,0.6)] ring-1 ring-ns-gold/40 transition-transform duration-300 hover:scale-110">
        <MessageCircle className="h-6 w-6" />
      </a>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
